import React from 'react'
import Popup from 'reactjs-popup'
import _ from 'lodash'

const ResourceHeader = ({ resource }) => (
  <div>
    {resource.resourceTitle}
    {!_.isEmpty(resource) && !resource.resourceOutlookAuthorized && (
      <Popup
        on="hover"
        contentStyle={{ whiteSpace: 'pre-wrap' }}
        trigger={<span className="dot dot--red">●</span>}
      >
        <div>
          User's Outlook is unauthorized.
          Data can't be fetched and updated.
        </div>
      </Popup>
    )}
  </div>
)

export default ResourceHeader
